<template>
  <a-drawer :title="title" width="60%" :visible="visible" :body-style="{ paddingBottom: '80px' }" @close="hide">
    <a-spin :spinning="loading">
      <div class="drawer-content">
        <a-descriptions title="基本信息" :column="2" bordered>
          <a-descriptions-item label="模块标识">{{ detailData.id || '-' }}</a-descriptions-item>
          <a-descriptions-item label="模块名称">{{ detailData.moduleName || '-' }}</a-descriptions-item>
          <a-descriptions-item label="模块类型">
            <a-tag :color="getModuleTypeColor(detailData.moduleSystemType)">
              {{ getModuleTypeText(detailData.moduleSystemType) }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="模块上级">{{ detailData.parentId || '-' }}</a-descriptions-item>
          <a-descriptions-item label="状态">
            <a-tag :color="detailData.status === 1 ? 'green' : 'red'">
              {{ detailData.status === 1 ? '正常' : '禁用' }}
            </a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="创建时间">{{ formatTime(detailData.createTime) || '-' }}</a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="扩展信息" :column="2" bordered style="margin-top: 16px" v-if="hasExtendInfo">
          <a-descriptions-item label="扩展 String 1" v-if="detailData.extendS1">
            {{ detailData.extendS1 }}
          </a-descriptions-item>
          <a-descriptions-item label="扩展 String 2" v-if="detailData.extendS2">
            {{ detailData.extendS2 }}
          </a-descriptions-item>
          <a-descriptions-item label="扩展 String 3" v-if="detailData.extendS3">
            {{ detailData.extendS3 }}
          </a-descriptions-item>
        </a-descriptions>

        <a-descriptions title="其它信息" :column="1" bordered style="margin-top: 16px">
          <a-descriptions-item label="描述">{{ detailData.description || '-' }}</a-descriptions-item>
          <a-descriptions-item label="备注">{{ detailData.remark || '无备注' }}</a-descriptions-item>
        </a-descriptions>
      </div>
    </a-spin>

    <div class="drawer-footer">
      <a-button @click="hide">关闭</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { getModuleDetail } from '@/api/system/module'
import { message } from 'ant-design-vue'

export default {
  name: 'DetailDrawer',
  data() {
    return {
      visible: false,
      loading: false,
      detailData: {},
    }
  },
  computed: {
    title() {
      return '功能模块详情'
    },
    hasExtendInfo() {
      return this.detailData.extendS1 || this.detailData.extendS2 || this.detailData.extendS3
    },
  },
  methods: {
    show(record) {
      this.visible = true
      this.loadDetail(record.id)
    },
    hide() {
      this.visible = false
      this.detailData = {}
    },
    async loadDetail(id) {
      this.loading = true
      try {
        const response = await getModuleDetail(id)
        if (response && response.data) {
          this.detailData = response.data
        } else {
          message.error('获取详情失败')
        }
      } catch (error) {
        console.error('获取详情失败:', error)
        message.error('获取详情失败')
      } finally {
        this.loading = false
      }
    },
    formatTime(time) {
      if (!time) return '-'
      return new Date(time).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
    },
    getModuleTypeText(type) {
      const map = {
        0: '平台模块',
        1: '系统内置',
        2: '其它模块',
      }
      return map[type] || '-'
    },
    getModuleTypeColor(type) {
      const map = {
        0: 'blue',
        1: 'green',
        2: 'orange',
      }
      return map[type] || 'default'
    },
  },
}
</script>

<style scoped>
.drawer-content {
  padding: 0;
}

.drawer-footer {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}

.ant-descriptions {
  margin-bottom: 0;
}

:deep(.ant-descriptions-title) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
